import { MerchantDM } from "./merchant_dm";
import { ContactDetailsDM } from "./contact_detail_dm";
import { CategoryDM } from "./category_dm";

export class VoucherPointDM {
  constructor({
    name = "",
    description = "",
    description_ind = "",
    points = 0,
    website = "",
    valid_from = "",
    valid_until = "",
    redeemable = "",
    tier = "",
    thumbnail_img_url = "",
    quantity = 0,
    points_label = "",
    additional_info = "",
    additional_info_link = "",
    merchant = {},
    contact_details = {},
    category = {},
  }) {
    this.name = name;
    this.description = description;
    this.description_ind = description_ind;
    this.points = points;
    this.website = website;
    this.valid_from = valid_from;
    this.valid_until = valid_until;
    this.redeemable = redeemable;
    this.tier = tier;
    this.thumbnail_img_url = thumbnail_img_url;
    this.quantity = quantity;
    this.points_label = points_label;
    this.additional_info = additional_info;
    this.additional_info_link = additional_info_link;
    this.merchant = merchant;
    this.contact_details = contact_details;
    this.category = category;
  }

  static fromJson(json) {
    return new VoucherPointDM({
      name: json["name"],
      description: json["description"],
      description_ind: json["description_ind"],
      points: json["points"],
      website: json["website"],
      valid_from: json["valid_from"],
      valid_until: json["valid_until"],
      redeemable: json["redeemable"],
      tier: json["tier"],
      thumbnail_img_url: json["thumbnail_img_url"],
      quantity: json["quantity"],
      points_label: json["points_label"],
      additional_info: json["additional_info"],
      additional_info_link: json["additional_info_link"],
      merchant: MerchantDM.fromJson(json["merchant"]),
      contact_details: ContactDetailsDM.fromJson(json["contact_details"]),
      category: CategoryDM.fromJson(json["category"]),
    });
  }
}
